import { render, staticRenderFns } from "./LandingAlert.vue?vue&type=template&id=056cee95&scoped=true"
import script from "./LandingAlert.vue?vue&type=script&lang=js"
export * from "./LandingAlert.vue?vue&type=script&lang=js"
import style0 from "./LandingAlert.vue?vue&type=style&index=0&id=056cee95&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056cee95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056cee95')) {
      api.createRecord('056cee95', component.options)
    } else {
      api.reload('056cee95', component.options)
    }
    module.hot.accept("./LandingAlert.vue?vue&type=template&id=056cee95&scoped=true", function () {
      api.rerender('056cee95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingAlert.vue"
export default component.exports